import { PropsWithChildren } from 'react';
import './styles.css';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.snow.css';

type RenderQuillContentProps = {
    className?: string;
    content: string;
};

const RenderQuillContent = (props: RenderQuillContentProps) => {
    let { content, className } = props;

    if (content.startsWith('"') || content.endsWith('"')) {
        content = JSON.parse(content);
    }

    return (
        <div
            id='editor-content'
            className={className}
            dangerouslySetInnerHTML={{ __html: content }}
        ></div>
    );
};

export default RenderQuillContent;
